import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SiteNav.css';

export const SiteNav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 8);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      // Store current scroll position
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
    } else {
      // Restore scroll position
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
      }
    }

    return () => {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
      }
    };
  }, [isMenuOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isMenuOpen]);

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const pathname = location.pathname.replace(/\/$/, ''); // Remove trailing slash
  const isDarkRoute = pathname === '/contact' || pathname === '/ai-drama';

  return (
    <nav className={`rl-nav ${isScrolled ? 'rl-nav--scrolled' : ''} ${isDarkRoute ? 'rl-nav--dark' : ''}`}>
      <div className="rl-nav__container">
        <Link to="/" className="rl-nav__logo">
          Renée Louise
        </Link>

        {/* Desktop Navigation */}
        <div className="rl-nav__links">
          <Link
            to="/services"
            className={`rl-nav__link ${isActive('/services') ? 'rl-nav__link--active' : ''}`}
            aria-current={isActive('/services') ? 'page' : undefined}
          >
            Services
          </Link>
          <Link
            to="/the-guide"
            className={`rl-nav__link rl-nav__link--guide ${isActive('/the-guide') ? 'rl-nav__link--active' : ''}`}
            aria-current={isActive('/the-guide') ? 'page' : undefined}
          >
            The Guide
          </Link>
          <Link
            to="/ai-drama"
            className={`rl-nav__link rl-nav__link--guide ${isActive('/ai-drama') ? 'rl-nav__link--active' : ''}`}
            aria-current={isActive('/ai-drama') ? 'page' : undefined}
          >
            AI Drama
          </Link>
          <Link
            to="/resources"
            className={`rl-nav__link ${isActive('/resources') ? 'rl-nav__link--active' : ''}`}
            aria-current={isActive('/resources') ? 'page' : undefined}
          >
            Resources
          </Link>
          <Link
            to="/about"
            className={`rl-nav__link ${isActive('/about') ? 'rl-nav__link--active' : ''}`}
            aria-current={isActive('/about') ? 'page' : undefined}
          >
            About
          </Link>
          <Link
            to="/contact"
            className={`rl-nav__link ${isActive('/contact') ? 'rl-nav__link--cta' : ''}`}
            aria-current={isActive('/contact') ? 'page' : undefined}
          >
            Book a call
          </Link>
        </div>

        {/* Mobile Navigation */}
        <div className="rl-nav__mobile">
          <Link to="/contact" className="rl-nav__mobile-cta">
            Book a call
          </Link>
          <button
            className="rl-nav__menu-button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-menu"
            aria-label="Menu"
          >
            <span className={`rl-nav__menu-icon ${isMenuOpen ? 'rl-nav__menu-icon--open' : ''}`}>
              <span className="rl-nav__menu-line"></span>
              <span className="rl-nav__menu-line"></span>
            </span>
          </button>
        </div>
      </div>

      {/* Mobile Menu Panel */}
      {isMenuOpen && (
        <div className="rl-nav__panel" id="mobile-menu">
          <span className="rl-nav__panel-label">MENU</span>
          <div className="rl-nav__panel-links">
            <Link
              to="/services"
              className="rl-nav__panel-link"
              onClick={handleLinkClick}
            >
              Services
            </Link>
            <Link
              to="/the-guide"
              className="rl-nav__panel-link rl-nav__panel-link--guide"
              onClick={handleLinkClick}
            >
              The Guide
            </Link>
            <Link
              to="/ai-drama"
              className="rl-nav__panel-link rl-nav__panel-link--guide"
              onClick={handleLinkClick}
            >
              AI Drama
            </Link>
            <Link
              to="/resources"
              className="rl-nav__panel-link"
              onClick={handleLinkClick}
            >
              Resources
            </Link>
            <Link
              to="/about"
              className="rl-nav__panel-link"
              onClick={handleLinkClick}
            >
              About
            </Link>
            <Link
              to="/contact"
              className="rl-nav__panel-link"
              onClick={handleLinkClick}
            >
              Book a call
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};
